<template>
  <div class="finance_box" ref="myElementRef">
    <div ref="searchBox" v-if="state.flng">
      <hc-search :data="serchData" @serch="getSarch($event)" @getadd="getadd($event)" />
    </div>
    <!-- 表格 -->
    <div class="table_box">
      <hc-table 
        :tableData="tableData" 
        :column="state.tableHeader" 
        :offsetHeight="state.offsetHeight"
        :maxPage="maxPage"
        @pageChange="pageChange($event)"
        @limitChange="limitChange($event)"
      >
        <template #device_img_url="{ row }">
          <el-image 
            v-if="row.device_img_url" 
            :src="row.device_img_url" 
            :preview-src-list="[row.device_img_url]"
            style="width: 50px; height: 50px; border-radius: 4px;"
            fit="cover"
            preview-teleported
            referrerpolicy="no-referrer"
          />
          <span v-else>-</span>
        </template>
        <template #device_png_url="{ row }">
          <el-image 
            v-if="row.device_png_url" 
            :src="row.device_png_url" 
            :preview-src-list="[row.device_png_url]"
            style="width: 50px; height: 50px; border-radius: 4px; background-color: #f5f7fa;"
            fit="contain"
            preview-teleported
            referrerpolicy="no-referrer"
          />
          <span v-else>-</span>
        </template>
        <template #status="{ row }">
          <el-tag :type="row.status == 1 ? 'success' : 'danger'">
            {{ row.status == 1 ? '正常' : '禁用' }}
          </el-tag>
        </template>
        <template #operation="scope">
          <div class="btn_box_det">
            <el-button size="small" type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" link @click="del(scope.row)">删除</el-button>
          </div>
        </template>
      </hc-table>
    </div>

    <!-- 弹窗 -->
    <el-dialog align-center v-model="dialogVisible" title="设备台账信息" width="550" draggable>
      <div class="userAdd_man">
        <el-form label-width="auto" :model="formLabelAlign" class="userFrom" ref="formRef" :rules="rules">
          <el-form-item label="设备ID" v-if="formLabelAlign.id > 0">
            <el-input v-model="formLabelAlign.device_id" disabled />
          </el-form-item>
          <el-form-item label="序列号" prop="device_sn">
            <el-input v-model="formLabelAlign.device_sn" placeholder="请输入序列号" />
          </el-form-item>
          <el-form-item label="设备类型" prop="device_type">
            <el-select v-model="formLabelAlign.device_type" placeholder="请选择设备类型" style="width: 100%;">
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="设备名称" prop="device_name">
            <el-input v-model="formLabelAlign.device_name" placeholder="请输入设备名称" />
          </el-form-item>
          <el-form-item label="设备编号" prop="device_number">
            <el-input v-model="formLabelAlign.device_number" placeholder="请输入设备编号" />
          </el-form-item>
          <el-form-item label="生产厂商" prop="manufacturer">
            <el-input v-model="formLabelAlign.manufacturer" placeholder="请输入生产厂商" />
          </el-form-item>
          <el-form-item label="系统固件版本" prop="firmware_version">
            <el-input v-model="formLabelAlign.firmware_version" placeholder="请输入系统固件版本" />
          </el-form-item>
          <el-form-item label="工序类型" prop="work_process">
            <el-input v-model="formLabelAlign.work_process" placeholder="请输入工序类型" />
          </el-form-item>
          <el-form-item label="硬件型号" prop="hardware_model">
            <el-input v-model="formLabelAlign.hardware_model" placeholder="请输入硬件型号" />
          </el-form-item>
          <el-form-item label="出厂日期" prop="manufacture_date">
            <el-date-picker
              style="width: 100%;"
              value-format="YYYY-MM-DD"
              v-model="formLabelAlign.manufacture_date"
              type="date"
              placeholder="选择出厂日期"
            />
          </el-form-item>
          <el-form-item label="租户企业名称" prop="tenant_name">
            <el-select v-model="formLabelAlign.tenant_name" placeholder="请选择租户企业名称" style="width: 100%;" filterable clearable>
              <el-option v-for="item in tenantOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="formLabelAlign.status" placeholder="请选择状态" style="width: 100%;">
              <el-option label="正常" :value="1" />
              <el-option label="禁用" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" :rows="3" v-model="formLabelAlign.remark" placeholder="请输入备注" />
          </el-form-item>
        </el-form>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="subimt($refs.formRef)">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { EquipmentLedgerAdd, EquipmentLedgerList, EquipmentLedgerDel } from '@/api/equipmentLedger.js';
import { EquipmentClassificationSelectList } from '@/api/equipmentClassification.js';
import { TenantDropdownList } from '@/api/tenant.js';

const router = useRouter();
const myElementRef = ref();
const searchBox = ref();
let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const dialogVisible = ref(false);
const tenantOptions = ref([]);
const typeOptions = ref([]);

const rules = reactive({
  device_sn: [
    { required: true, message: "序列号不能为空", trigger: "blur" }
  ],
  device_name: [
    { required: true, message: "设备名称不能为空", trigger: "blur" }
  ],
  device_number: [
    { required: true, message: "设备编号不能为空", trigger: "blur" }
  ],
  device_type: [
    { required: true, message: "设备类型不能为空", trigger: "change" }
  ]
});

const tableData = ref([]);

const serchData = reactive([
  {
    label: "设备名称",
    type: "input",
    value: "",
  },
  {
    label: "",
    type: "add",
    value: true
  }
]);

const state = reactive({
  title: "",
  column: [
    {
      type: "index",
      show: true,
      label: "序号",
      width: 80,
    },
    {
      prop: "device_id",
      show: true,
      label: "设备ID",
      width: 180,
    },
   
    {
      prop: "device_name",
      show: true,
      label: "设备名称",
      width: 200,
    },
    {
      prop: "device_number",
      show: true,
      label: "设备编号",
      width: 180,
    },
    {
      prop: "device_img_url",
      show: true,
      label: "设备大图",
      width: 150,
    },
    {
      prop: "device_png_url",
      show: true,
      label: "设备png图",
      width: 150,
    },
    {
      prop: "manufacturer",
      show: true,
      label: "生产厂商",
      width: 200,
    },
    {
      prop: "firmware_version",
      show: true,
      label: "系统固件版本",
      width: 150,
    },
    {
      prop: "work_process",
      show: true,
      label: "工序类型",
      width: 200,
    },
    {
      prop: "device_type",
      show: true,
      label: "设备类型",
      width: 200,
    },
    {
      prop: "device_sn",
      show: true,
      label: "序列号",
      width: 150,
    },
    {
      prop: "hardware_model",
      show: true,
      label: "硬件型号",
      width: 200,
    },
    {
      prop: "manufacture_date",
      show: true,
      label: "出厂日期",
      width: 200,
    },
    {
      prop: "status",
      show: true,
      label: "状态",
      width: 200,
    },
    {
      prop: "tenant_name",
      show: true,
      label: "租户企业名称",
      width: 200,
    },
    {
      prop: "project_name",
      show: true,
      label: "所属项目",
      width: 200,
    },
    {
      prop: "project_area",
      show: true,
      label: "施工面积(㎡)",
      width: 150,
    },
    {
      prop: "remark",
      show: true,
      label: "备注",
      width: 200,
    },
    {
      prop: "created_at",
      show: true,
      label: "创建时间",
      width: 260,
    },
    {
      prop: "operation",
      show: true,
      label: "操作",
      width: 140, 
    },
  ],
  flng: true,
  offsetHeight: 0,
  tableHeader: [],
});

const formLabelAlign = reactive({
  id: 0,
  device_id: "",
  device_sn: "",
  device_type: "",
  device_name: "",
  device_number: "",
  manufacturer: "",
  firmware_version: "",
  work_process: "",
  hardware_model: "",
  manufacture_date: "",
  status: 1,
  tenant_name: "",
  remark: ""
});

onMounted(() => {
  getTenantList();
  try {
    nextTick(() => {
      offHeighths();
    });
    window.onresize = () => {
      nextTick(() => {
        offHeighths();
      });
    };
    tableHeaderFn();
  } catch { }
  getList();
  getClassificationList();
});

const getTenantList = async () => {
  try {
    const res = await TenantDropdownList();
    if (res.code === 200) {
      tenantOptions.value = res.data || [];
    }
  } catch (e) {
    console.error("加载租户列表失败", e);
  }
};

// 获取设备分类，用于设备类型选择
const getClassificationList = async () => {
  try {
    const res = await EquipmentClassificationSelectList();
    if (res.code === 200) {
      typeOptions.value = res.data || [];
    }
  } catch (e) {
    console.error("加载设备分类失败", e);
  }
};

const offHeighths = () => {
  if (myElementRef.value) {
    state.offsetHeight =
      myElementRef.value?.offsetHeight - 130 - searchBox.value?.offsetHeight;
  }
};

onUnmounted(() => {
  window.onresize = null;
});

const getadd = () => {
  router.push('/equipment/equipmentLedgerEdit');
};

const edit = (row) => {
  router.push({
    path: '/equipment/equipmentLedgerEdit',
    query: { id: row.id }
  });
};

// 查询
const getSarch = (data) => {
  page.value = 1;
  getList();
};

const pageChange = (currentPage) => {
  page.value = currentPage;
  getList();
};

const limitChange = (currentLimit) => {
  page.value = 1;
  limit.value = currentLimit;
  getList();
};

// 表头筛选
const tableHeaderFn = () => {
  state.tableHeader = state.column.filter((v) => {
    if (v.show) {
      return v.show == true;
    } else {
      v.show = false;
    }
  });
};

const getList = async () => {
  const res = await EquipmentLedgerList({
    current: page.value,
    size: limit.value,
    deviceName: serchData[0].value
  });
  if (res.code === 200 && res.data) {
    tableData.value = res.data.records || [];
    maxPage.value = res.data.total || 0;
  } else {
    tableData.value = [];
    maxPage.value = 0;
  }
};

const subimt = async (formEl) => {
  if (!formEl) return;

  await formEl.validate(async (valid) => {
    if (valid) {
      try {
        const data = { ...formLabelAlign };
        const res = await EquipmentLedgerAdd(data);
        if (res.code === 200) {
          dialogVisible.value = false;
          ElMessage.success('保存成功');
          getList();
        } else {
          ElMessage.error(res.msg || '保存失败');
        }
      } catch (error) {
        ElMessage.error('保存失败，请重试');
      }
    } else {
      ElMessage.warning('请填写完整的信息');
    }
  });
};

const del = (row) => {
  ElMessageBox.confirm('确认要删除该设备台账信息吗？', '删除提醒', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    getDel(row);
  }).catch(() => {});
};

const getDel = async (row) => {
  const res = await EquipmentLedgerDel({
    id: row.id
  });
  if (res.code === 200) {
    ElMessage.success('删除成功');
    getList();
  } else {
    ElMessage.error(res.msg || '删除失败');
  }
};
</script>

<style lang="less" scoped>
.finance_box {
  flex: 1;
  overflow: auto;
  background-color: #fff;
  border-radius: 6px;
  padding: 10px;
  margin-right: 10px;
}

.btn_box {
  height: 40px;
  display: flex;
}

.table_box {
  width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
  background-color: #1e6aed;
  border: none;
}

.serBtn {
  margin-left: 10px;
  background-color: #f0f0f0;
  color: #000;
  border: none;
}

.serBtn:hover {
  background-color: #f0f0f0;
  color: #000;
}

.opBtn {
  margin: 0 !important;
}

.opBtn:hover {
  color: #e6a755;
}

.userAdd_man {
  min-height: 360px;
  overflow: auto;
  padding: 0 30px;
}

.userFrom {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;
}

.el-form-item {
  margin-bottom: 0;
}
</style>
